exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.overflow-on .cell {\r\n  overflow: visible;\r\n  overflow-x: visible;\r\n  overflow-y: visible;\n}\n.el-form-item--medium .el-form-item__label {\r\n  text-align: right;\n}\n.el-form-item--medium .el-form-item__content {\r\n  text-align: left;\n}\n.ml {\r\n  text-align: left;\r\n  margin-left:150px;\n}\r\n\r\n", ""]);

// exports
